// extracted by mini-css-extract-plugin
export default {"tabs":"tabs_tabs__MF-pB","tabs__item":"tabs_tabs__item__tBPHE","tabsHeader__item":"tabs_tabsHeader__item__PVdzb","active":"tabs_active__BPx6E"};